import { Box } from "@material-ui/core";
import { formatTimestamp } from "swyft-react-core";

import { useStyles } from "../checkoutSuccessPage.styles";
import { Quote } from "../../../api/Quote/Quote";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { quoteDepositAmount } from "../../../app/utils";

export const HeroSection = ({ quote }: { quote: Quote }) => {
  const classes = useStyles();
  const { isMoreThanSm } = useBreakpoint();

  return (
    <Box className={classes.heroSection}>
      <Box className="check-icon" marginBottom={isMoreThanSm ? "60px" : "28px"}>
        <img src="images/checkout-success/check_icon.svg" alt="checkout-success" />
      </Box>
      <Box
        fontSize={isMoreThanSm ? "34px" : "20px"}
        color="#f9f9f9"
        fontWeight={500}
        marginBottom={isMoreThanSm ? "42px" : "20px"}
      >
        You're <span className={classes.colorOrange}>booked!</span>
      </Box>
      <Box
        maxWidth={isMoreThanSm ? "794px" : "100%"}
        textAlign={"center"}
        color="#f9f9f9"
        fontSize={isMoreThanSm ? "20px" : "12px"}
        fontWeight={400}
        marginBottom={isMoreThanSm ? "63px" : "28px"}
      >
        You are now part of over 12,500 Swyft Energy customers all across Ireland who have choosen us to upgrade the
        energy efficency of their property
      </Box>
      <Box
        width={isMoreThanSm ? "536px" : "100%"}
        padding={isMoreThanSm ? "50px" : "30px"}
        bgcolor={"#f9f9f9"}
        fontSize={isMoreThanSm ? "16px" : "12px"}
        color="#4b5462"
        borderRadius={"10px"}
        marginBottom={isMoreThanSm ? "129px" : 0}
      >
        <Box>
          <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
            <Box>Mobile</Box>
            <Box color="#1e073f">{String("*******").concat((quote.customer?.mobilePhone ?? "").slice(7))}</Box>
          </Box>
          <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} marginTop={"10px"}>
            <Box>Email</Box>
            <Box color="#1e073f">{String("*******").concat((quote.customer?.email ?? "").slice(7))}</Box>
          </Box>
          <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} marginTop={"10px"}>
            <Box>Deposit Paid</Box>
            <Box color="#1e073f">€{quoteDepositAmount(quote)}.00</Box>
          </Box>
        </Box>
        <Box marginTop={isMoreThanSm ? "30px" : "10px"}>
          <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
            <Box>Booking Reference</Box>
            <Box color="#1e073f">{quote.name}</Box>
          </Box>
          {quote.requestedInstallationDate && (
            <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"} marginTop={"10px"}>
              <Box>Booking Date</Box>
              <Box color="#1e073f">
                {quote.requestedInstallationDate &&
                  formatTimestamp(new Date(quote.requestedInstallationDate).getTime())}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
